// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"50ed8495","252":"b12b022f","346":"7b08f59c","361":"23f1f1ca","427":"8db8f480","437":"09484124","453":"9abbcebc","501":"2d52e41b","507":"22919575","520":"e4f015d1","582":"f750de14","729":"02114347","947":"30e5db96"}[chunkId] + ".chunk.js";
};